/**
 * Enum representing the grading status of an exam instance.
 */
export enum GradingStatusEnum {
  /** Grading has not started - no essay questions scored yet */
  NotStarted = 0,
  /** Grading is in progress - some essay questions scored */
  InProgress = 1,
  /** Grading is complete - all essay questions scored */
  Complete = 2,
}

/**
 * Summary of grading status for an exam instance.
 */
export interface ExamInstanceGradingSummary {
  examInstanceId: string;
  gradingStatus: GradingStatusEnum;
  totalQuestions: number;
  gradedQuestions: number;
  ungradedQuestions: number;
  totalCompetencies: number;
  passedCompetencies: number;
  realizedScore: number;
  totalScore: number;
  hasPassed: boolean | null;
  competencySummaries: CompetencyGradingSummary[];
}

/**
 * Summary of grading status for a competency group.
 */
export interface CompetencyGradingSummary {
  examInstanceGroupId: string;
  name: string;
  totalQuestions: number;
  gradedQuestions: number;
  realizedScore: number;
  hasPassed: boolean;
}
